module.exports = __webpack_public_path__ + "media/styles/images/png/pencil-teal-on-white-54be742a2b9967ab3131d01ad71c502a.png";